import * as React from "react";
import { PatientPersonalProfile } from "@curefit/ups-common";
import IinfoQues from "../../../models/staticData/IinfoQues";
import Questionnaire from "../../common/Questionnaire";
import * as _ from "lodash";
import {ITypeFormQuestionnaire} from "../../../models/ITypeFormQuestionnaire";
import TypeFormContainer from "../../../containers/TypeFormContainer";
import {TypeAheadElement} from "../../TypeAhead";
import AppUtils from "../../../utils/AppUtils";

interface PersonalInfoEditorProps {
    staticPersonalInfo: IinfoQues;
    personalInfos: PatientPersonalProfile;
    updateHandler: (profile: PatientPersonalProfile, key: string) => void;
    questionnaire?: ITypeFormQuestionnaire[];
    questionIdList?: string[];
}
export default class PersonalInfoEditor extends React.Component<PersonalInfoEditorProps> {
    constructor(props: PersonalInfoEditorProps) {
        super(props);
        this.state = {
            majorEvents: ""
        };
    }

    updateStateToValue = (stateKey: string, value: any, callback?: any) => {
        switch (stateKey) {
            case "majorLifeEvents" :
                this.setState({majorLifeEvents : value}, callback);
                break;
        }
    }

    personalInfoChangeHandler  = (updatedPersonalInfo: any, key: string) => {
        let personalInfos = {...this.props.personalInfos};
        if (_.isEmpty(updatedPersonalInfo)) {
            delete  personalInfos[key];
        } else {
            personalInfos[key] = updatedPersonalInfo;
        }
        this.props.updateHandler(personalInfos, key);
    }

    handleTypeAheadChange = (input: string, stateKey: string) => {
        this.updateStateToValue(stateKey, input);
        let dishTypeAhead: TypeAheadElement[] = [];
        if (input !== "") {
            let defaultTypeAheadElement = { value: "", label: input, isDefault: true };
            dishTypeAhead.push(defaultTypeAheadElement);
        }
        return Promise.resolve({options: dishTypeAhead, completed: true});

        /**
         * @TODO -
         * Only the typed item will be written from here,
         * When proper APIs are ready the following code should be uncommented
         * and the action should be replaced with the action which calls the API
         */
        // return this.props.fetchDishByDishName(input).then((dishes: IDishCatalogueResponse[]) => {
        //     let dishTypeAhead: TypeAheadElement[] = [];
        //     if (input !== "") {
        //         let defaultTypeAheadElement = { value: "", label: input, isDefault: true };
        //         dishTypeAhead.push(defaultTypeAheadElement);
        //     }
        //     _.map(dishes, (dish: IDishCatalogueResponse) => {
        //         let typeAheadElement: TypeAheadElement = {
        //             value: dish.esId,
        //             label: dish.name
        //         }
        //         dishTypeAhead.push(typeAheadElement);
        //     })
        //     return Promise.resolve({options: dishTypeAhead, completed: true});
        // }).catch((error: any) => {
        //     throw error;
        // });
    }

    onListItemRemove = (index: number, key: string) => {
        let personalInfos: any = AppUtils.getDeepCopiedObject(this.props.personalInfos);
        personalInfos[key].value.splice(index, 1);
        this.props.updateHandler(personalInfos, key);
    }

    handleListItemTypeAheadSelect = (elem: TypeAheadElement, key: string) => {
        let personalInfos: any = { ...this.props.personalInfos };
        let updatedValue = !_.isEmpty(personalInfos[key]) ? personalInfos[key] : { comment: "", value: [] };
        updatedValue.value = _.isEmpty(updatedValue.value) ? [] : updatedValue.value;
        let updatedList = [...updatedValue.value, { displayValue: elem.label, internalValue: elem.label }];
        updatedValue.value = updatedList;
        personalInfos[key] = updatedValue;

        this.updateStateToValue(key, "", () => {
            this.props.updateHandler(personalInfos, key)
        });
    }

    changeHandler  = (updatedPersonalInfo: any, key: string) => {
        let personalInfos: PatientPersonalProfile = {...this.props.personalInfos};
        personalInfos[key] = updatedPersonalInfo;
        this.props.updateHandler(personalInfos, key);
    }

    render() {
        let {staticPersonalInfo} = this.props;
        return (<div className="personal-info-editor">
            {
                !_.isEmpty(this.props.questionnaire) &&
                <TypeFormContainer typeFormData={this.props.questionnaire} questionIdList={this.props.questionIdList}/>
            }
            {staticPersonalInfo && staticPersonalInfo.questionnaire.map((question, index: number) => {
                let answer = this.props.personalInfos[question.key] ? this.props.personalInfos[question.key] : null;
                if(_.isArray(answer)) {
                    answer = answer[0];
                }
                return <div key={index} className="personal-info-ques-container">
                    <Questionnaire question={question} answer={answer} updateHandler={this.personalInfoChangeHandler} onTypeHeadChangeHandler={this.handleTypeAheadChange}
                        typeAheadString={this.state[question.key]} onTypeAheadSelect={this.handleListItemTypeAheadSelect} onListItemRemove={this.onListItemRemove}
                        hideComment={question.key === "goalPreferences" ? true : false}/>
                </div>
            })}
        </div>)
    }
}